import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import NewsSection from './components/NewsSection';
import ServicesOverview from './components/ServicesOverview';
import PlansOverview from './components/PlansOverview';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesOverview />
        <PlansOverview />
        <NewsSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
